<template>

  <div>
    <search-list :projectList="projectList" :projectId="projectId" :functionAreaId="$route.params.fid" @searchData="findData"></search-list>
    <div class="page-wrapper">
    <table-list
        :columns="columns"
        :current="current"
        :data="data"
        :total="total"
        :loading="loading"
        @change-page="changPage"
    >
      <Button type="primary" class="btn" @click="addGoods" v-p="{api:'archives/add'}">添加物品</Button>
      <Button type="primary" class="btn" @click="goodsTransfer" v-p="{api:'archives/transferGoodsIn'}">转入物品</Button>
      <Button type="primary" class="btn" @click="exportGoods" v-p="{api:'archives/batchImport'}">批量导入</Button>
    </table-list>
    </div>
    <modify-status-modal :n="statusKey" :projectId="projectId" :configArea="configArea" :configAreaFid="configAreaFid" :compensate="compensate" :goodsArchivesCode="goodsArchivesCode" :curStatus="curStatus" @refresh="findData(searchData)"></modify-status-modal>
    <delete-goods-modal :n="deleteKey" :goodsArchivesCode="goodsArchivesCode" :goodsName="goodsName" @refresh="findData(searchData)"></delete-goods-modal>
    <goods-transfer-modal :n="transferKey" ></goods-transfer-modal>
    <batch-import-modal :n="importKey"></batch-import-modal>
  </div>

</template>

<script type="text/ecmascript-6">
import { getGoodsList } from 'api/archives'
import { getBuildInfo } from 'api/functionalArea'
import SearchList from './components/SearchList';
import ModifyStatusModal from './components/ModityStatusModal';
import DeleteGoodsModal from './components/DeleteGoodsModal';
import GoodsTransferModal from './components/GoodsTransferModal';
import BatchImportModal from './components/BatchImportModal';
import TableList from 'components/TableList/index';
import { formatMoney } from '@/utils/format'
export default {
    name:'filemanagement',
    components: {
      SearchList,
      TableList,
      ModifyStatusModal,
      DeleteGoodsModal,
      GoodsTransferModal,
      BatchImportModal
    },
    created(){
      this.updateTableList()
    },
    activated(){
      if(this.$route.params.projectId&&this.$route.params.fid){
        this.updateTableList()
      }
    },
    data(){
      return {
        total:0,
        current:1,
        loading:false,
        statusKey:0,
        deleteKey:0,
        transferKey:0,
        importKey:0,
        goodsName:'',
        projectId:'',
        projectList:[],
        configArea:null,
        configAreaFid:'',
        compensate:null,
        goodsArchivesCode:'',
        curStatus:0,
        searchData:{
          projectId:'',
          functionAreaId: '',
          channel:'',
          minPrice: null,
          maxPrice:null,
          bigCategoryCode:'',
          smallCategoryCode:'',
          useStatus:'',
          goodsBelong:'',
          goodsName:"",
          goodsArchivesCode:'',
          roomId:'',
          barCode:'',
          page:1,
          limit:10,
        },
        columns:[
          {
            type:'index',
            width:60,
            align:'center'
          },
          {
            title:' '
          },
          {
            title:'物品名称',
            width:150,
            align:'center',
            key:'goodsName'
          },
          {
            title:' '
          },
          {
            title:'大类',
            width:60,
            align:'center',
            key:'bigCategoryName'
          },
          {
            title:' '
          },
          {
            title:'小类',
            width:160,
            align:'center',
            key:'smallCategoryName'
          },
          {
            title:' '
          },
          {
            title:'物品编码',
            width:240,
            align:'center',
            key:'goodsArchivesCode'

          },
          {
            title:' '
          },
          {
            title:'项目名称',
            width:160,
            align:'center',
            key:'projectName'
          },
          {
            title:' '
          },
          {
            title:'功能区／房间号',
            width:120,
            align:'center',
            key:'configAreaExpr'

          },
          {
            title:' '
          },
          {
            title:'取得方式',
            width:120,
            align:'center',
            key:'channelStr'
          },
          {
            title:' '
          },
          {
            title:'物品归属',
            width:120,
            align:'center',
            key:'goodsBelongStr'
          },
          {
            title:' '
          },
          {
            title:'采购价格',
            width:100,
            align:'center',
            key:'configCost',
            render: (h,params) => {
              return h('div', {
                style:{
                  'text-align':'right'
                }
              },formatMoney(params.row.configCost))
            }
          },
          {
            title:' '
          },
          {
            title:'状态',
            width:120,
            align:'center',
            key:'useStatusStr'
          },
          {
            title:' '
          },
          {
            title:'操作',
            key:'action',
            width:280,
            fixed: 'right',
            align:'center',
            render:(h,params) => {
              return h('div',[h('Button',{
                props: {
                  type:'primary',
                  size:'small'
                },
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'archives/detail'
                    }
                  }
                ],
                style: {
                  marginRight: '5px'
                              },
                on:{
                  click: () => {
                    this.$store.dispatch("updateReadCode", params.row.goodsArchivesCode)
                    this.$router.push({ name: 'checkgoods'})
                  }
                }
              },'查看'),h('Button',{
                props: {
                  type:'success',
                  size:'small',
                  disabled: params.row.useStatus===2 ||params.row.useStatus===3
                },
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'archives/update'
                    }
                  }
                ],
                style: {
                  marginRight: '5px'
                },
                on:{
                  click: () => {
                    this.$store.dispatch("updateModifyCode", params.row.goodsArchivesCode)
                    this.$router.push({ name: 'modifygoods' })
                  }
                }
              },'修改'),
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small',
                  disabled: params.row.useStatus === 2 || params.row.useStatus === 3
                },
                directives: [
                  {
                    name: 'p',
                    value: {
                      api: 'archives/updateGoodsStatus'
                    }
                  }
                ],
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.statusKey++;
                    this.projectId = params.row.projectId
                    this.goodsArchivesCode = params.row.goodsArchivesCode
                    this.configArea = params.row.configArea
                    this.configAreaFid = params.row.configAreaFid
                    this.curStatus = params.row.useStatus
                    this.compensate = params.row.valuation
                  }
                }
              },'状态变更'),
              h('Button',{
                props: {
                  type: 'error',
                  size: 'small',
                },
                directives: [
                  {
                    name: 'p',
                    value: {
                      api: 'archives/delete'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.projectId = params.row.projectId
                    this.goodsName = params.row.goodsName;
                    this.goodsArchivesCode = params.row.goodsArchivesCode;
                    this.deleteKey++;
                  }
                }
              },'删除')])
            }
          }
        ],
        data:[]
      }
    },
    methods:{
      addGoods(){
        this.$router.push({ name: 'addgoods' })
      },
      goodsTransfer() {
        this.transferKey++
      },
      exportGoods() {
        this.importKey++
      },
      changFlag() {
        this.flag = false
      },
      changPage(n){
        this.current = n;
        this.searchData.page = n
        this.initTableList()
      },
      findData(searchData) {
        this.current = 1;
        this.searchData = searchData
        this.searchData.page = 1
        this.initTableList()
      },
      updateTableList(){
        getBuildInfo().then( res => {
            this.projectList = res.data
            this.projectId = res.data[0].value
            this.searchData.projectId  = this.$route.params.projectId ? this.$route.params.projectId:this.projectId
            this.searchData.functionAreaId = this.$route.params.fid ? this.$route.params.fid:''
            this.initTableList(this.searchData)
          })
      },
      initTableList() {
        getGoodsList(this.searchData).then( res => {
          this.data = res.data.rows
          this.total = res.data.total
        }).catch((error)=>{
          console.log(error)
        })
      }
    }
}
</script>

<style lang="css" scoped>
 .btn {
   margin-bottom: 16px;
 }
</style>
